import React from "react";
import { L10n } from "@fidget/common/i18n";
import { AgentButton } from "@fidget/common/components/inputs/buttons/agentButton/agentButton";
import styles from "./icons.css";

interface Props {
  onSave(): void;
  onDiscard(): void;
}
export const ElementFormSaveDiscardIcon = ({ onDiscard, onSave }: Props) => {
  return (
    <>
      <div className={styles.discard} onClick={onDiscard}>
        <i className="icon-close-cross" />
        <L10n id={"settings.discard"} />
      </div>
      <AgentButton onClick={onSave}>
        <L10n id={"conversation.input.save"} />
      </AgentButton>
    </>
  );
};
